import { createApi } from "@reduxjs/toolkit/query/react";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";

const commonApi = createApi({
    reducerPath: 'commonApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        deleteMember: builder.query({
            query: (details) => ({
                url: `/MembershipTask/DeleteTaskListDetailsByTaskId?id=${details.id}&id1=${details.isCorporateMember}&id2=${details.isAcademicMember}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getPDF: builder.query({
            query: (details) => ({
                url: `/Common/getPDF?type=${details.type}&fileName=${details.fileName}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getImage: builder.query({
            query: (details) => ({
                url: `/Common/getImage?type=${details.type}&fileName=${details.fileName}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        storeBase64Image: builder.mutation({
            query: (details) => ({
                url: '/Common/StoreBase64Image',
                method: 'POST',
                body: details,
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        SaveGMAPDocuments: builder.mutation({
            query: (details) => ({
                url: '/GMAPAccount/SaveGMAPDocuments',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        uploadPDF: builder.mutation({
            query: (details) => ({
                url: '/Common/UploadPDF',
                method: 'POST',
                body: details,
                formData: true
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        gMapMemberSignUp: builder.mutation({
            query: (details) => ({
                url: '/GMAPAccount/GMAPMemberSignUp',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        HtmlToPdfDownload: builder.mutation({
            query: (details) => ({
                url: '/Common/HtmlToPdfDownload',
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetFinanceReceiptInvoice: builder.mutation({
            query: (details) => ({
                url: '/MembershipPayment/GetFinanceReceiptInvoice',
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        // GetFinanceReceiptInvoiceRequest: builder.query({
        //     query: (details) => ({
        //         url: `/MembershipPayment/GetFinanceReceiptInvoiceRequest?`,
        //         method: 'GET',
        //         responseHandler: (response) => response.blob(),
        //     }),
        //     transformResponse: transformSucessResponse,
        //     transformErrorResponse: transformErrorResponse,
        // }),
        deleteViewMember: builder.query({
            query: (details) => ({
                url: `/AcademicMember/DeleteViewMembersDetailsByMemberId?id=${details.id}&id1=${details.isCorporateMember}&id2=${details.isAcademicMember}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useLazyDeleteMemberQuery,
    useStoreBase64ImageMutation,
    useSaveGMAPDocumentsMutation,
    useUploadPDFMutation,
    useLazyGetPDFQuery,
    useLazyGetImageQuery,
    useGMapMemberSignUpMutation,
    useHtmlToPdfDownloadMutation,
    useGetFinanceReceiptInvoiceMutation,
    useLazyDeleteViewMemberQuery,
} = commonApi;

export default commonApi;